// Only public CMS raster images on the configured API are sent through IPX.
// Width-only resizing preserves the original composition and authored dimensions.
const escapeAttribute = (value) =>
  String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('"', '&quot;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;');
export function articleImageSources(
  source,
  apiUrl,
  baseURL = '/',
  cover = false
) {
  let url;
  try {
    const api = new URL(apiUrl);
    url = new URL(source, api);
    if (
      !['http:', 'https:'].includes(url.protocol) ||
      url.origin !== api.origin ||
      !/^\/uploads\/blogs\/.+\.(?:webp|avif|png|jpe?g)$/i.test(url.pathname) ||
      url.username ||
      url.password ||
      url.search ||
      url.hash
    )
      return null;
  } catch {
    return null;
  }
  const base = String(baseURL || '/').replace(/\/+$/, '');
  const variant = (width) =>
    `${base}/_ipx/f_webp,q_78,w_${width}/${encodeURIComponent(url.href)}`;
  return {
    original: url.href,
    src: variant(cover ? 960 : 768),
    srcset: [320, 480, 640, 768, 960, 1200]
      .map((width) => `${variant(width)} ${width}w`)
      .join(', '),
    sizes: cover
      ? '(min-width: 992px) 960px, calc(100vw - 32px)'
      : '(min-width: 800px) 760px, calc(100vw - 32px)'
  };
}

export function responsiveArticleImages(html, apiUrl, baseURL = '/') {
  // Preserve authored picture/art-direction, responsive sources and handlers.
  return String(html).replace(
    /<picture\b[^>]*>[\s\S]*?<\/picture>|<img\b((?:"[^"]*"|'[^']*'|[^'">])*)>/gi,
    (match, attrs) => {
      if (
        attrs === undefined ||
        /(?:^|\s)(?:srcset|sizes|onerror)\s*=/i.test(attrs)
      )
        return match;
      const source = attrs.match(
        /(?:^|\s)src\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s"'=<>`]+))/i
      );
      if (!source) return match;
      const value = source.slice(1).find((value) => value !== undefined);
      const image = articleImageSources(value, apiUrl, baseURL);
      if (!image) return match;
      const selfClosing = /\/\s*$/.test(attrs);
      const clean = attrs.replace(source[0], '').replace(/\/\s*$/, '');
      return `<img${clean} src="${escapeAttribute(image.src)}" srcset="${escapeAttribute(image.srcset)}" sizes="${escapeAttribute(image.sizes)}" data-original-src="${escapeAttribute(image.original)}" onerror="this.onerror=null;this.removeAttribute('srcset');this.src=this.dataset.originalSrc;"${selfClosing ? ' /' : ''}>`;
    }
  );
}

/** Card slots, not full article-body widths. Reuse the existing strict origin/path validation. */
export function articleCardImageSources(source, apiUrl, baseURL = '/') {
  const safe = articleImageSources(source, apiUrl, baseURL);
  if (!safe) return null;
  const base = String(baseURL || '/').replace(/\/+$/, '');
  const variant = (width) =>
    `${base}/_cards/${width}/${encodeURIComponent(safe.original)}`;
  return {
    original: safe.original,
    src: variant(480),
    srcset: [320, 480, 640, 768, 960]
      .map((w) => `${variant(w)} ${w}w`)
      .join(', '),
    sizes:
      '(min-width: 1216px) 373px, (min-width: 1024px) calc((100vw - 96px) / 3), (min-width: 640px) calc((100vw - 72px) / 2), calc(100vw - 32px)'
  };
}
